import { deepMerge } from 'js/utils/Utils'
import { roundEx } from 'js/utils/Maths'

import Common from 'js/_core/Common'
import EventHandler from 'js/modules/_base/events/helper/EventHandler'

const defaults = {
  fpsDigit: 1000,
  baseFps: 60,
  multiplierMin: 1,
  digit: 10000,
  useStats: false,
}

export default class Raf extends EventHandler {
  constructor(options = {}) {
    super()

    this.raf = null

    this.prevTime = 0
    this.deltaTime = 0
    this.fpsMultiplier = 1

    deepMerge(this, defaults, options)
  }

  init() {
    this.useStats = Common.debug || this.useStats
    this.fps = roundEx(this.fpsDigit / this.baseFps, this.digit)
    this.raf = requestAnimationFrame(this._onRaf.bind(this))

    if (this.useStats) {
      import('stats-js').then((module) => {
        this.stats = module.default()
        document.body.appendChild(this.stats.dom)
        this.stats.dom.style.display = 'none'
        Common.switchDevMode()
      })
    }
  }

  destroy() {
    cancelAnimationFrame(this.raf)
    super.destroy()
  }

  _updateHandler(timestamp) {
    this.handler.forEach((item) => {
      item.task(timestamp, this.deltaTime)
    })
  }

  _calcFps(timestamp = 0) {
    this.deltaTime = timestamp - this.prevTime
    this.fpsMultiplier = roundEx(this.fps / this.deltaTime, this.digit)
    this.fpsMultiplier = Math.max(this.fpsMultiplier, this.multiplierMin)

    this.prevTime = timestamp
  }

  _onRaf(timestamp = 0) {
    if (this.stats) this.stats.begin()

    this._calcFps(timestamp)
    this._updateHandler(timestamp)

    if (this.stats) this.stats.end()
    this.raf = requestAnimationFrame(this._onRaf.bind(this))
  }
}